import React from 'react'

// Without a boundary, any error thrown while rendering (e.g. a session pushed without its
// fields) unmounts the whole app and leaves a white page. This keeps a way back.
class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { failed: false }
  }

  static getDerivedStateFromError() {
    return { failed: true }
  }

  componentDidCatch(error, info) {
    console.error('Page crashed:', error, info?.componentStack)
  }

  render() {
    if (!this.state.failed) return this.props.children
    return (
      <div style={{ maxWidth: '480px', margin: '80px auto', textAlign: 'center', padding: '0 20px' }}>
        <h2 style={{ marginBottom: '8px' }}>Something went wrong on this page</h2>
        <p style={{ color: '#6b7280', marginBottom: '16px' }}>
          Reload the page to continue.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            padding: '8px 20px',
            border: '1px solid #1976d2',
            borderRadius: '4px',
            background: '#1976d2',
            color: 'white',
            fontSize: '15px',
            cursor: 'pointer',
          }}>
          Reload
        </button>
      </div>
    )
  }
}

export default AppErrorBoundary
